import React, { useEffect, useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AgGrid from '../../shared/agGrid/agGrid.component';
import Navigation from '../../shared/navigation.component';
import {
  fetchE2eNotifications,
  updateE2eNotificationFlag,
} from './store/actions';
import {
  e2eNotificationsSelector,
  e2eNotificationsLoadingSelector,
  e2eNotificationsUpdatingSelector,
} from './store/selectors';
import { columnDefinitions } from './columnDefinitions';

const E2eHealthcheckPage = ({
  notifications,
  isLoading,
  updatingJobIds,
  fetchE2eNotifications,
  updateE2eNotificationFlag,
}) => {
  const [onlyErrors, setOnlyErrors] = useState(true);

  useEffect(() => {
    fetchE2eNotifications(onlyErrors);
  }, [fetchE2eNotifications, onlyErrors]);

  const handleFilterChange = useCallback(value => {
    setOnlyErrors(value === 'errors');
  }, []);

  const context = useMemo(() => ({
    onToggleErrorFlag: updateE2eNotificationFlag,
    updatingJobIds,
    onlyErrors,
  }), [updateE2eNotificationFlag, updatingJobIds, onlyErrors]);

  return (
    <div className="e2e-healthcheck-page">
      <div className="page">
        <div className="container-fluid">
          <div className="row no-gutters page-content-container">
            <div className="col">
              <div className="d-flex align-items-center justify-content-between">
                <h5>E2E Healthcheck</h5>
              </div>
            </div>
          </div>
          <div className="row no-gutters page-content-container">
            <div className="col">
              <Navigation
                activeElement={onlyErrors ? 'errors' : 'all'}
                onChange={handleFilterChange}
                definitions={[
                  { label: 'Show: Errors', type: 'errors' },
                  { label: 'Show: All records', type: 'all' },
                ]}
              />
            </div>
          </div>
          <div className="row no-gutters page-content-container">
            <div className="col">
              <div className="ag-grid-full-page-with-secondary-menu">
                <AgGrid
                  rowData={notifications}
                  columnDefs={columnDefinitions}
                  isGridLoading={isLoading}
                  withSearchBar
                  rowHeight={32}
                  context={context}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

E2eHealthcheckPage.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({
    jobId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    schemaType: PropTypes.string,
    schemaName: PropTypes.string,
    connName: PropTypes.string,
    periodName: PropTypes.string,
    subject: PropTypes.string,
    body: PropTypes.string,
    statusId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    createdOn: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    errorMsgFlag: PropTypes.string,
  })),
  isLoading: PropTypes.bool.isRequired,
  updatingJobIds: PropTypes.arrayOf(PropTypes.string),
  fetchE2eNotifications: PropTypes.func.isRequired,
  updateE2eNotificationFlag: PropTypes.func.isRequired,
};

E2eHealthcheckPage.defaultProps = {
  notifications: [],
  updatingJobIds: [],
};

const mapStateToProps = state => ({
  notifications: e2eNotificationsSelector(state),
  isLoading: e2eNotificationsLoadingSelector(state),
  updatingJobIds: e2eNotificationsUpdatingSelector(state),
});

export default connect(mapStateToProps, {
  fetchE2eNotifications,
  updateE2eNotificationFlag,
})(E2eHealthcheckPage);
